import { toast } from 'react-toastify'
import { useCart } from '../../../Providers/CartProvider'
import { useOffers } from '../../../Providers/OffersProvider'

const useHandleAddToBasketBtn = (product, quantity) => {
    const { addProductToBasket, updateProductInBasket, deleteInCart } = useCart()
    const { savedOfferId, handleAddUpdateProductToSavedOffer, handleGetSavedOffer, setSelectedSavedOffer } = useOffers()

    const handleBtnOnClick = async (operation) => {
        const baseUnit = product && product.baseUnit ? product.baseUnit.toLowerCase() : product.baseUnit

        debugger
        if (quantity <= 0 && operation === 'add') {
            return
        }
        if (savedOfferId == -1 && quantity == 0 && operation === 'update') {
            await deleteInCart(product)
            return
        }
        if (product.salesRatio && (quantity % product.salesRatio !== 0)) {
            toast.warning(`Niepoprawna ilość! Podana ilość musi być wielokrotnością pakietu sprzedażowego, który wynosi: ${product.salesRatio} ${baseUnit}`)
            return
        }
        if (savedOfferId != -1) {
            await handleAddUpdateProductToSavedOffer(product, quantity)
            const res = await handleGetSavedOffer(0, savedOfferId)
            setSelectedSavedOffer(res)
        }
        else {
            switch (operation) {
                case 'add':
                    await addProductToBasket(product.index, quantity)
                    break;
                case 'update':
                    await updateProductInBasket(product.index, quantity)
                    break
                default:
                    break
            }
        }
    }
    return { handleBtnOnClick }
}

export default useHandleAddToBasketBtn